// preloading-manager.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PreloadingManagerService {
    private preloadingEnabled = new BehaviorSubject<boolean>(true);
    preloadingEnabled$ = this.preloadingEnabled.asObservable();

    disablePreloading() {
        this.preloadingEnabled.next(false);
    }

    enablePreloading() {
        this.preloadingEnabled.next(true);
    }
}